//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowSelect(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M20 11L22 13H14.4102L22.71 21.29L21.29 22.71L13 14.4102V22L11 20V11H20Z" fill="currentColor" /><path d="M4 20H5V22H2V19H4V20Z" fill="currentColor" /><path d="M9 22H7V20H9V22Z" fill="currentColor" /><path d="M4 17H2V13H4V17Z" fill="currentColor" /><path d="M4 11H2V7H4V11Z" fill="currentColor" /><path d="M22 9H20V7H22V9Z" fill="currentColor" /><path d="M5 4H4V5H2V2H5V4Z" fill="currentColor" /><path d="M22 5H20V4H19V2H22V5Z" fill="currentColor" /><path d="M11 4H7V2H11V4Z" fill="currentColor" /><path d="M17 4H13V2H17V4Z" fill="currentColor" /></svg>;
}
export default IconArrowSelect;